import { useState } from 'react'

export function useSidebarCollapse(storageKey: string) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(storageKey) === 'true')

  const toggle = () => {
    setCollapsed(prev => {
      localStorage.setItem(storageKey, String(!prev))
      return !prev
    })
  }

  return { collapsed, toggle }
}
